import React from "react";
import { Box, Typography } from "@mui/material";
import { ExampleLines } from "../../flashcardUtils";
import PronunciationLine from "./PronunciationLine";

function RecallStage({ practiceCard, practiceMeta, practiceFlipped, onSetPracticeFlipped }) {
  return (
    <Box
      onClick={() => onSetPracticeFlipped((current) => !current)}
      sx={{
        perspective: "1200px",
        height: { xs: "min(55dvh, 440px)", md: "min(45dvh, 390px)" },
        cursor: "pointer",
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: "100%",
          transformStyle: "preserve-3d",
          transition: "transform 560ms cubic-bezier(.2,.72,.22,1)",
          transform: practiceFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            p: { xs: 3, md: 4 },
            borderRadius: "20px",
            bgcolor: practiceMeta.surface,
            border: "1.5px dashed #c8e9fb",
            backfaceVisibility: "hidden",
            display: "grid",
            placeItems: "center",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          <Box>
            <Typography sx={{ color: practiceMeta.accent, fontSize: 13, fontWeight: 800, textTransform: "uppercase", mb: 1 }}>
              Recall
            </Typography>
            <Typography sx={{ color: "var(--toeic-ink-deep)", fontSize: { xs: 40, md: 64 }, fontWeight: 800, lineHeight: 1.05 }}>
              {practiceCard.front}
            </Typography>
            <PronunciationLine card={practiceCard} accent={practiceMeta.accent} stopPropagation />
            <Typography sx={{ mt: 3, color: "var(--toeic-ink-soft)", fontSize: 14, fontWeight: 500 }}>
              Think of the meaning, then reveal.
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            p: { xs: 3, md: 4 },
            borderRadius: "20px",
            bgcolor: "#f7fff9",
            border: "1.5px dashed #b9e8cf",
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
            display: "grid",
            placeItems: "center",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          <Box className="lingualica-scrollarea" sx={{ maxHeight: "100%", overflowY: "auto", px: 0.5 }}>
            <Typography sx={{ color: "#35a86a", fontSize: 13, fontWeight: 800, textTransform: "uppercase", mb: 1 }}>
              Answer
            </Typography>
            <Typography sx={{ color: "var(--toeic-ink-deep)", fontSize: { xs: 26, md: 40 }, fontWeight: 800, lineHeight: 1.14 }}>
              {practiceCard.back}
            </Typography>
            {practiceCard.example && (
              <ExampleLines
                example={practiceCard.example}
                term={practiceCard.front}
                sx={{
                  mt: 2,
                  justifyItems: "center",
                  "& .MuiTypography-root": {
                    color: "var(--toeic-ink-soft)",
                    fontSize: { xs: 14.5, md: 16.5 },
                    lineHeight: 1.45,
                  },
                }}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default RecallStage;
